import React, { FC, useEffect } from "react";
import cn from "classnames";

import { useHookSubscribe } from "../../../../react-rxjs";
import { DataSourceControl } from "../../../../map/controls/DataSourceControl";
import { DimensionControl } from "../../../../map/controls/DimensionControl";
import { useMapStore } from "../../../../map/hooks/useMapStore";
import { useFavouriteProviderContext } from "../../../../map/providers/FavouriteProvider";
import { MapDimensionType } from "../../../../map/models/MapDimension";

import { FavouritesSettingsActions } from "../FavouritesSettingsActions";
import { FavouritesSettingsHeader } from "../FavouritesSettingsHeader";
import { useStyles } from "../FavouritesSettings.styles";

import { useMapStyles } from "./FavouritesSettingsMap.styles";
import { IFavouritesSettingsMapProps } from "./FavouritesSettingsMap.types";

export const FavouritesSettingsMap: FC<IFavouritesSettingsMapProps> = (props) => {
  const { item } = props;
  const classes = useStyles();
  const mapClasses = useMapStyles();
  const store = useMapStore();

  const {
    state: { isFavouriteChanged, savedFavouriteItem },
    actions: { deleteFavourite, updateFavourite, cancelFavouriteChanges },
  } = useFavouriteProviderContext();

  useEffect(() => {
    return store.refresh;
  }, [store]);

  const dimensions = useHookSubscribe([], store.dimensions$);

  return (
    <div className={classes.root}>
      <FavouritesSettingsHeader item={item} />
      <div className={cn(classes.settingsContainer, mapClasses.settings)}>
        <DataSourceControl />
        {dimensions
          .filter((e) => e.visible && e.type !== MapDimensionType.Calendar)
          .map((e) => (
            <DimensionControl dimension={e} key={e.id} />
          ))}
      </div>
      <FavouritesSettingsActions
        onDelete={deleteFavourite}
        onSave={updateFavourite}
        onCancel={cancelFavouriteChanges}
        isChanged={isFavouriteChanged}
        savedFavouriteItem={savedFavouriteItem}
      />
    </div>
  );
};
